import { inject, Pipe, PipeTransform } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';

@Pipe({
  name: 'hasTopicHint',
  standalone: true,
})
export class HasTopicHintPipe implements PipeTransform {
  readonly #translateService = inject(TranslocoService);

  public transform(value: string): boolean {
    const key = `tickets.create.topic.defaults.${value}`;
    return value && this.#translateService.translate(key) !== key;
  }
}
